import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { aldagramPageMeta, aldagramSchema } from 'components/common/schema'
import Template from 'components/cases/aldagram'

const Aldagram: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...aldagramPageMeta} />
      <JsonLd data={aldagramSchema} />
      <Template />
    </>
  )
}

export default Aldagram
